export default __webpack_public_path__ + "static/media/detalle-resultado.578b8145.png";